import React, { useState } from "react";
import ReactDOM from 'react-dom'
import classes from "./draggable.module.css";
import Button from "../Auth/button";
import Input from "../Auth/Input";
import Collapsable from "./collapsable";
import axios from "../../Axios";
import {useDispatch} from 'react-redux'
const inputStates = {
  tag: null,
  color: null,
  score: null
};
const Drag = ({ dragOut, newResponseHandler }) => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);

  const resetItems = () => {
    setItems([]);
  };
  const clickHandler = () => {
    const tempItems = [...items];
    tempItems.push({ ...inputStates });
    setItems(tempItems);
  };

  const changeHandler = (e, ind) => {
    const tempItems = [...items];
    const { name, value } = e.target;
    tempItems[ind][name] = value;

    setItems(tempItems);
  };

  const saveHandler = async (e) => {
    e.preventDefault();
    try{
    const save = await axios.post("/response/new", {
      responses: [...items],
    });

    const {payload} = save.data;
    dispatch({type: 'ADD_RESPONSE', payload: payload})
  }
  catch(err){
    console.log(err);
  }
  };

  const cancelHandler = async (e) => {
    e.preventDefault();
    newResponseHandler();
    resetItems();
  };

  const inputs = items.map((input, index) => {
    return (
      <Collapsable
        extraClass={classes.collapsable}
        heading={
          input.tag !== null && input.tag !== "" ? (
            <>
            <div
              style={{ backgroundColor: input.color, display: "inline-block" }}
              className={classes.preview}
            >
              {input.tag}
            </div>

            <span style={{display: "inline", marginLeft: "1rem"}}>Score: {input.score}</span>
            </>
          ) : (
            <div
              style={{ backgroundColor: input.color }}
              className={classes.preview}
            >{`item ${index + 1}`}</div>
          )
        }
        inputs={
          <div className={classes.card}>
            <Input
              HolderClass={classes.input}
              name="tag"
              extraClass={[classes.innerInput]}
              placeholder={"Enter Tag"}
              onChange={(e) => changeHandler(e, index)}
              value={input.tag}
            ></Input>
            <Input
              type="color"
              HolderClass={classes.input}
              name="color"
              extraClass={[classes.innerInput]}
              placeholder={"Enter Color"}
              onChange={(e) => changeHandler(e, index)}
              value={input.color}
            ></Input>

            <Input
              type="Number"
              HolderClass={classes.input}
              name="score"
              extraClass={[classes.innerInput]}
              placeholder={"Enter Score"}
              onChange={(e) => changeHandler(e, index)}
              value={input.score}
            ></Input>
          </div>
        }
      ></Collapsable>
    );
  });
  return (
      ReactDOM.createPortal(<div
        className={
          dragOut
            ? [classes.draggable, classes["draggable_out"]].join(" ")
            : classes.draggable
        }
      >
        <div className={classes.heading}>
          <div>Add Response</div>
          <Button onClick={saveHandler} extraClass={classes.saveBtn}>
            Save
          </Button>
  
          <Button onClick={cancelHandler} extraClass={classes.cancelBtn}>
            Cancel
          </Button>
        </div>
  
        {inputs}
  
        <Button extraClass={classes.addItem} onClick={clickHandler}>
          add item
        </Button>
      </div>, document.getElementById("right_sidebar"))
    
  );
};
export default Drag;
